<template>
  <div class="filter-modal small-filter-modal">
    <Slider
      :value="cost"
      :min-value="minCost"
      :max-value="maxCost"
      :indent="20"
      :pre-str="currencySign"
      class="my-4 cost-slider"
      @changeValue="getCost"
    />
    <ModalButtons
      :value="cost"
      :reset="resetCost"
      :select="chooseCost"
      class="mt-2"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import constants from '@/dependencies/constants'
import ModalButtons from '@/components/Common/FilterModalButtons'
import Slider from '~/components/Common/Slider'

export default {
  name: 'Cost',
  components: {
    Slider,
    ModalButtons
  },
  props: {
    costVal: {
      type: Array,
      default: () => this.defaultValue
    }
  },
  data() {
    return {
      cost: null
    }
  },
  computed: {
    ...mapGetters({
      currencySign: 'user/getCurrencySign'
    }),
    minCost() {
      return constants.COMMON.MIN_COST
    },
    maxCost() {
      return constants.COMMON.MAX_COST
    },
    defaultValue() {
      return [this.minCost, this.maxCost]
    }
  },
  watch: {
    costVal(val) {
      this.cost = val ?? this.defaultValue
    }
  },
  methods: {
    ...mapActions({
      setCost: 'search/SET_COST'
    }),
    chooseCost() {
      this.setCost(this.cost)
      this.$emit('clicked')
    },
    resetCost() {
      this.setCost(null)
      this.cost = this.defaultValue
    },
    getCost(cost) {
      this.cost = cost
    }
  }
}
</script>

<style scoped lang="scss">
@import '~assets/css/variables.scss';

input {
  max-width: 40px;
}
.values-wrapper {
  display: flex;
  font-size: 18px;
  font-weight: lighter;
}
.dash {
  width: 16px;
  text-align: center;
}
.el-slider__bar {
  background-color: $primary !important;
}
</style>
